var navigation = new function () {
    this.doToggle = function (event, el) {
        $(el).siblings('.flogas-navigation__sub').slideToggle('fast');
        $(el).parent().toggleClass('is-active');
    };
    this.doToggleMobile = function (event, el) {
        $(el).siblings('.flogas-navigation__inner').slideToggle('fast');
        $(el).closest('.flogas-navigation').toggleClass('is-active');
    };
};